<div class="dropdown-wrapper" selectExpand>
  <div class="select-wrapper">
    @if (clear) {
      {{ placeholder }}
    } @else {
      <span>{{ SelectLabel ? SelectLabel : placeholder }}</span>
    }
  </div>
  <ng-content select=".icons"> </ng-content>

  <div class="drop-list">
    <ul>
      @for (items of optionList; track items) {
        <li
          (click)="selectdropdown(items)"
          (keydown.enter)="selectdropdown(items)"
          (keydown.space)="selectdropdown(items)"
          [ngClass]="{ active: SelectLabel == items[label] }"
        >
          <label for="">{{ items[label] }}</label>
        </li>
      }
    </ul>
  </div>
</div>
